import Button from "@mui/material/Button";
import React from "react";

interface ButtonSecondaryProps {
  onClick?: () => void;
  children?: React.ReactNode;
  sx?: object;
  [key: string]: any; // pour permettre d'autres props MUI comme "disabled", "type", etc.
}

const ButtonSecondary: React.FC<ButtonSecondaryProps> = ({
  onClick,
  children,
  sx,
  ...rest
}) => {
  return (
    <Button
      onClick={onClick}
      variant="outlined"
      sx={{
        borderColor: "hsl(var(--border))",
        color: "hsl(var(--foreground))",
        textTransform: "none",
        py: "8px",
        px: "16px",
        borderRadius: "6px",
        "&:hover": {
          backgroundColor: "hsl(var(--muted))",
          borderColor: "hsl(var(--border))",
        },
        "&:disabled": {
          borderColor: "hsl(var(--muted))",
          color: "hsl(var(--muted-foreground))",
        },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default ButtonSecondary;
